export { default } from './Pagination';


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-pagination/es/index.js
// module id = 259
// module chunks = 0